import React from 'react'
import { ButtonPrimary } from './atoms'
import './EmptyList.css'

export type AddButtonInfo = {
  onClick: () => void
  text: string
  dataCy?: string
}

type Props = {
  message: string
  icon: string
  addButtonInfo?: AddButtonInfo
}

function EmptyList(props: Props) {
  const { message, addButtonInfo, icon } = props

  return (
    <div className="empty-list">
      <div className="empty-list-medallion">
        <i className={icon}></i>
      </div>
      <div>
        {message}
      </div>
      {addButtonInfo && (
        <div className="empty-list-button-container">
        <ButtonPrimary data-cy={addButtonInfo.dataCy} onClick={addButtonInfo.onClick}>+ {addButtonInfo.text}</ButtonPrimary>
        </div>
      )}
    </div>
  )
}

export default EmptyList
